import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ObservationLabsComponent } from "./observation.labs/observation.labs.component";
import { PatientComponent } from "./patient/patient.component";
import { PatientResolver } from "./patient/patient.resolver";
import { PatientDetailComponent } from "./patient.detail/patient.detail.component";
import { DefaultComponent } from "./default/default.component";
import { InfoComponent } from "./info/info.component";
import { ErrorComponent } from "./error/error.component";
import { MedicationsComponent } from "./medications/medications.component";
import { ObservationVitalSignsComponent } from "./observation.vital-signs/observation.vital-signs.component";
import { MedicationsResolver } from "./medications/medications.resolver";
import { PatientImportComponent } from "./patient.import/patient.import.component";
import {LandingPageComponent} from "./landing.page/landing.page.component";
import { AuthGuard } from "./guards/auth.guard";

const routes: Routes = [
  {
    path: "",
    component: LandingPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "landing",
    component: LandingPageComponent,
    pathMatch: "full",
    canActivate: [AuthGuard]
  },
  {
    path: "patient-component",
    component: PatientComponent,
    pathMatch: "full",
    resolve: {
      pageData: PatientResolver,
    },
    canActivate: [AuthGuard]
  },
  {
    path: "patient-import",
    component: PatientImportComponent,
    pathMatch: "full",
    resolve: {
      pageData: PatientResolver,
    },
    canActivate: [AuthGuard]
  },
  {
    path: "patientdetail",
    component: PatientDetailComponent,
    canActivate: [AuthGuard],
    resolve: {
      pageData: PatientResolver,
    },
    children: [
      {
        path: "",
        component: DefaultComponent,
        pathMatch: "full",
      },
      {
        path: "priority",
        component: ObservationLabsComponent,
      },
      {
        path: "labs",
        component: ObservationLabsComponent,
      },
      {
        path: "medications",
        component: MedicationsComponent,
        pathMatch: "full",
        resolve: {
          medicationData:  MedicationsResolver,
        },
        runGuardsAndResolvers: 'always'
      },
      {
        path: "vitalsigns",
        component: ObservationVitalSignsComponent,
        pathMatch: "full",
      },
      {
        path: "info",
        component: InfoComponent,
      },
      {
        path: "error",
        component: ErrorComponent,
      },
    ],
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { initialNavigation: "disabled" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
export const routingComponents = [PatientComponent, PatientDetailComponent, PatientImportComponent, LandingPageComponent];
